import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Loader from './layout/Loader';
import CustomComponent from './layout/Component';
import PageNotFound from './pages/NotFound';
import { routes as all_routes } from './route/Routes';

function App() {
  const [loading, setLoading] = useState(false);
  return loading ? (
    <Loader />
  ) : (
    <Routes>
      {all_routes?.map((item, i) => (
        <Route key={i} path={item.path} element={<CustomComponent Component={item.component} />}>
          {item?.children?.length &&
            item?.children?.map((child: any, inx: any) => (
              <Route
                key={inx}
                path={`/${child.path}`}
                element={<CustomComponent Component={child.component} />}
              />
            ))}
        </Route>
      ))}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
